import axios from "axios";
import { Applicant_URL, CommonListing_URL } from "../Url";

export const fetchAppDetailsActions = {
  FETCH_APPLICANT_DETAILS: "FETCH_APPLICANT_DETAILS",
  FETCH_APPLICANT_DETAILS_SUCCESS: "FETCH_APPLICANT_DETAILS_SUCCESS",
  FETCH_APPLICANT_DETAILS_ERROR: "FETCH_APPLICANT_DETAILS_ERROR",
  LOGOUT: "LOGOUT",
};

const accessToken = "0366a651-e178-46a2-9515-02efbc0beebc";

export function fetchAppDetails(props) {
  const { access_token, applicationId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/get/ApplicationDetails/ByApplicationId?applicationId=${applicationId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(fetchAppDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(fetchAppDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(fetchAppDetailsError(err));
          return err.response;
        }
      });
}

export function fetchAppDetailsRequest() {
  return {
    type: fetchAppDetailsActions.FETCH_APPLICANT_DETAILS,
    isPosting: true,
  };
}
export function fetchAppDetailsError(error) {
  return {
    type: fetchAppDetailsActions.FETCH_APPLICANT_DETAILS_ERROR,
    payload: error,
  };
}

export function fetchAppDetailsSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: fetchAppDetailsActions.FETCH_APPLICANT_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const fetchAppTopSecActions = {
  FETCH_APPLICATION_TOP_SEC: "FETCH_APPLICATION_TOP_SEC",
  FETCH_APPLICATION_TOP_SEC_SUCCESS: "FETCH_APPLICATION_TOP_SEC_SUCCESS",
  FETCH_APPLICATION_TOP_SEC_ERROR: "FETCH_APPLICATION_TOP_SEC_ERROR",
  LOGOUT: "LOGOUT",
};

export function fetchAppTopSec(props) {
  const { access_token, applicationId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/get/ApplicationTopSection/ByApplicationId?applicationId=${applicationId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(fetchAppTopSecSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(fetchAppTopSecError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(fetchAppTopSecError(err));
          return err.response;
        }
      });
}

export function fetchAppTopSecRequest() {
  return {
    type: fetchAppTopSecActions.FETCH_APPLICATION_TOP_SEC,
    isPosting: true,
  };
}
export function fetchAppTopSecError(error) {
  return {
    type: fetchAppTopSecActions.FETCH_APPLICATION_TOP_SEC_ERROR,
    payload: error,
  };
}

export function fetchAppTopSecSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: fetchAppTopSecActions.FETCH_APPLICATION_TOP_SEC_SUCCESS,
      payload: props,
    });
  };
}

export const submitApplicationActions = {
  SUBMIT_APPLICATION: "SUBMIT_APPLICATION",
  SUBMIT_APPLICATION_SUCCESS: "SUBMIT_APPLICATION_SUCCESS",
  SUBMIT_APPLICATION_ERROR: "SUBMIT_APPLICATION_ERROR",
};

export function submitApplication(props) {
  const { access_token, applicationId, userIdWhenDeviation } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/submit/Application?applicationId=${applicationId}&userIdWhenDeviation=${userIdWhenDeviation}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(submitAppSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(submitAppError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(submitAppError(err));
          return err.response;
        }
      });
}

export function submitAppRequest() {
  return {
    type: submitApplicationActions.SUBMIT_APPLICATION,
    isPosting: true,
  };
}
export function submitAppError(error) {
  return {
    type: submitApplicationActions.SUBMIT_APPLICATION_ERROR,
    payload: error,
  };
}

export function submitAppSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: submitApplicationActions.SUBMIT_APPLICATION_SUCCESS,
      payload: props,
    });
  };
}

export const rejectApplicationActions = {
  REJECT_APPLICATION: "REJECT_APPLICATION",
  REJECT_APPLICATION_SUCCESS: "REJECT_APPLICATION_SUCCESS",
  REJECT_APPLICATION_ERROR: "REJECT_APPLICATION_ERROR",
};

export function rejectApplication(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      data: values,
      url: `${CommonListing_URL}/reject/Application`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(rejectAppSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(rejectAppError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(rejectAppError(err));
          return err.response;
        }
      });
}

export function rejectAppRequest() {
  return {
    type: rejectApplicationActions.REJECT_APPLICATION,
    isPosting: true,
  };
}
export function rejectAppError(error) {
  return {
    type: rejectApplicationActions.REJECT_APPLICATION_ERROR,
    payload: error,
  };
}

export function rejectAppSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: rejectApplicationActions.REJECT_APPLICATION_SUCCESS,
      payload: props,
    });
  };
}

export const holdApplicationActions = {
  HOLD_APPLICATION: "HOLD_APPLICATION",
  HOLD_APPLICATION_SUCCESS: "HOLD_APPLICATION_SUCCESS",
  HOLD_APPLICATION_ERROR: "HOLD_APPLICATION_ERROR",
};

export function holdApplication(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      data: values,
      url: `${CommonListing_URL}/hold/Application`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(holdAppSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(holdAppError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(holdAppError(err));
          return err.response;
        }
      });
}

export function holdAppRequest() {
  return {
    type: holdApplicationActions.HOLD_APPLICATION,
    isPosting: true,
  };
}
export function holdAppError(error) {
  return {
    type: holdApplicationActions.HOLD_APPLICATION_ERROR,
    payload: error,
  };
}

export function holdAppSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: holdApplicationActions.HOLD_APPLICATION_SUCCESS,
      payload: props,
    });
  };
}

export const unholdApplicationActions = {
  UNHOLD_APPLICATION: "UNHOLD_APPLICATION",
  UNHOLD_APPLICATION_SUCCESS: "UNHOLD_APPLICATION_SUCCESS",
  UNHOLD_APPLICATION_ERROR: "UNHOLD_APPLICATION_ERROR",
};

export function unholdApplication(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      data: values,
      url: `${CommonListing_URL}/unhold/Application`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(unholdAppSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(unholdAppError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(unholdAppError(err));
          return err.response;
        }
      });
}

export function unholdAppRequest() {
  return {
    type: unholdApplicationActions.UNHOLD_APPLICATION,
    isPosting: true,
  };
}
export function unholdAppError(error) {
  return {
    type: unholdApplicationActions.UNHOLD_APPLICATION_ERROR,
    payload: error,
  };
}

export function unholdAppSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: unholdApplicationActions.UNHOLD_APPLICATION_SUCCESS,
      payload: props,
    });
  };
}

export const assignedToMeActions = {
  ASSIGNED_TO_ME_APP: "ASSIGNED_TO_ME_APP",
  ASSIGNED_TO_ME_APP_SUCCESS: "ASSIGNED_TO_ME_APP_SUCCESS",
  ASSIGNED_TO_ME_APP_ERROR: "ASSIGNED_TO_ME_APP_ERROR",
};

export function assignedToMeApp(props) {
  const { access_token, applicationId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${CommonListing_URL}/assign/Application/ToMe?applicationId=` +
        applicationId,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(assignedToMeAppSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(assignedToMeAppError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(assignedToMeAppError(err));
          return err.response;
        }
      });
}

export function assignedToMeAppRequest() {
  return {
    type: assignedToMeActions.ASSIGNED_TO_ME_APP,
    isPosting: true,
  };
}
export function assignedToMeAppError(error) {
  return {
    type: assignedToMeActions.ASSIGNED_TO_ME_APP_ERROR,
    payload: error,
  };
}

export function assignedToMeAppSuccess(props) {
  //
  return (dispatch) => {
    dispatch({
      type: assignedToMeActions.ASSIGNED_TO_ME_APP_SUCCESS,
      payload: props,
    });
  };
}

////List count for application listing

export const getAppDataCountActions = {
  APP_LIST_COUNT: "APP_LIST_COUNT",
  APP_LIST_COUNT_SUCCESS: "APP_LIST_COUNT_SUCCESS",
  APP_LIST_COUNT_ERROR: "APP_LIST_COUNT_ERROR",
};

export function getAppDataCount(props) {
  const { access_token, processType } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/getAll/processTypeAndStatusCount?processType=${processType}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAppDataCountSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAppDataCountError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAppDataCountError(err));
          return err.response;
        }
      });
}

export function getAppDataCountRequest() {
  return {
    type: getAppDataCountActions.APP_LIST_COUNT,
    isPosting: true,
  };
}
export function getAppDataCountError(error) {
  return {
    type: getAppDataCountActions.APP_LIST_COUNT_ERROR,
    payload: error,
  };
}

export function getAppDataCountSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAppDataCountActions.APP_LIST_COUNT_SUCCESS,
      payload: props,
    });
  };
}
